import Swiper from 'swiper/bundle';

(function ($) {

	/**
	 * Cria um Swiper imediatamente (para sliders above-the-fold).
	 */
	function initSwiper(selector, options) {
		const el = document.querySelector(selector);
		if (!el) return null;
		return new Swiper(selector, options);
	}

	/**
	 * Cria um Swiper somente quando o elemento entrar no viewport.
	 * Retorna a instância assim que criada (via callback).
	 */
	function initSwiperLazy(selector, options, onInit) {
		const el = document.querySelector(selector);
		if (!el) return;

		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) return;
					obs.disconnect();
					const instance = new Swiper(selector, options);
					if (typeof onInit === 'function') onInit(instance);
				});
			},
			{ rootMargin: '200px' }  // começa a criar 200px antes de aparecer
		);

		observer.observe(el);
	}

	function sliders() {

		// ── Slider principal da home (above-the-fold — imediato) ──────────────
		initSwiper(".home-slider", {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			speed: 1000,
			autoplay: { delay: 6000, disableOnInteraction: false },
			navigation: {
				nextEl: ".home-slider .swiper-button-next",
				prevEl: ".home-slider .swiper-button-prev"
			},
		});

		// ── Hero blog (above-the-fold — imediato) ─────────────────────────────
		initSwiper('.blog-featured-slider', {
			loop: true,
			speed: 600,
			autoplay: { delay: 5000, disableOnInteraction: true },
			pagination: { el: '.blog-featured .swiper-pagination', clickable: true },
			navigation: {
				nextEl: ".blog-featured .swiper-button-next",
				prevEl: ".blog-featured .swiper-button-prev",
			},
		});

		// ── Hero genérico ─────────────────────────────────────────────────────
		initSwiper(".hero-slider", {
			slidesPerView: 1,
			loop: true,
			speed: 1000,
			autoplay: { delay: 5000, disableOnInteraction: true },
			pagination: { el: ".hero-slider .swiper-pagination", clickable: true },
		});

		// ── Blog slider (listagem) ─────────────────────────────────────────────
		initSwiperLazy(".blog-slider", {
			slidesPerView: "auto",
			spaceBetween: 16,
			loop: false,
			freeMode: true,
			navigation: {
				nextEl: ".blog-slider .swiper-buttons .swiper-button-next",
				prevEl: ".blog-slider .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				768: { navigation: false, allowTouchMove: false },
			},
		});

		// ── Valores da empresa ─────────────────────────────────────────────────
		if (window.innerWidth > 768) {
			initSwiperLazy(".our-values-slider", {
				slidesPerView: "auto",
				spaceBetween: 24,
				freeMode: true,
				navigation: {
					nextEl: ".our-values .swiper-buttons .swiper-button-next",
					prevEl: ".our-values .swiper-buttons .swiper-button-prev",
				},
			});
		}

		// ── Timeline ──────────────────────────────────────────────────────────
		initSwiperLazy(".timeline-slider", {
			slidesPerView: "auto",
			spaceBetween: 24,
			freeMode: true,
			navigation: {
				nextEl: ".about-history .swiper-buttons .swiper-button-next",
				prevEl: ".about-history .swiper-buttons .swiper-button-prev",
			},
		});

		// ── Vantagens App ──────────────────────────────────────────────────────
		initSwiperLazy(".app-advantages-slider", {
			slidesPerView: 3,
			spaceBetween: 10,
			grid: { rows: 3, fill: 'row' },
			navigation: {
				nextEl: ".app-advantages .swiper-buttons .swiper-button-next",
				prevEl: ".app-advantages .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0: { slidesPerView: 1, grid: { rows: 3, fill: 'row' } },
				768: { navigation: false, allowTouchMove: false },
			},
		});

		// ── Números ────────────────────────────────────────────────────────────
		initSwiperLazy(".numbers-slider", {
			slidesPerView: "auto",
			freeMode: true,
			breakpoints: {
				0:   { spaceBetween: 38 },
				768: { allowTouchMove: false },
			},
		});

		// ── Funções ────────────────────────────────────────────────────────────
		initSwiperLazy(".functions-slider", {
			slidesPerView: 3,
			spaceBetween: 40,
			freeMode: true,
			navigation: {
				nextEl: ".functions-slider .swiper-buttons .swiper-button-next",
				prevEl: ".functions-slider .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0: { slidesPerView: "auto", spaceBetween: 16 },
			},
		});

		// ── Cases ──────────────────────────────────────────────────────────────
		initSwiperLazy(".business-study-slider", {
			slidesPerView: 3,
			spaceBetween: 16,
			pagination: { el: ".business-study-slider .swiper-pagination", clickable: true },
			breakpoints: {
				0:   { slidesPerView: "auto", spaceBetween: 16 },
				768: { pagination: false, allowTouchMove: false },
			},
		});

		// ── Clientes ───────────────────────────────────────────────────────────
		initSwiperLazy(".clients-slider", {
			slidesPerView: 3,
			spaceBetween: 40,
			navigation: {
				nextEl: ".clients-slider .swiper-buttons .swiper-button-next",
				prevEl: ".clients-slider .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0:   { slidesPerView: 1, spaceBetween: 10 },
				768: { navigation: false, allowTouchMove: false, centerInsufficientSlides: true },
			},
		});

		// ── Parceiros ──────────────────────────────────────────────────────────
		initSwiperLazy(".partners-slider", {
			slidesPerView: 6,
			spaceBetween: 16,
			freeMode: true,
			navigation: {
				nextEl: ".partners-slider .swiper-buttons .swiper-button-next",
				prevEl: ".partners-slider .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0: { slidesPerView: 2, grid: { rows: 3, fill: 'row' } },
				768: { slidesPerView: 6 },
			},
		});

		// ── Benefícios Visa ────────────────────────────────────────────────────
		initSwiperLazy(".benefits-cardvisa-slider", {
			slidesPerView: 3,
			spaceBetween: 40,
			grid: { rows: 3, fill: 'row' },
			navigation: {
				nextEl: ".benefits-cardvisa .swiper-buttons .swiper-button-next",
				prevEl: ".benefits-cardvisa .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0:   { slidesPerView: 1, spaceBetween: 16, grid: { rows: 3, fill: 'row' } },
				768: { navigation: false, allowTouchMove: false },
			},
		});

		// ── Produtos Loja ──────────────────────────────────────────────────────
		initSwiperLazy(".shop-products-slider", {
			slidesPerView: 4,
			spaceBetween: 16,
			freeMode: true,
			navigation: {
				nextEl: ".shop-products-slider .swiper-buttons .swiper-button-next",
				prevEl: ".shop-products-slider .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0:   { slidesPerView: "auto", spaceBetween: 24 },
				768: { navigation: false, allowTouchMove: false },
			},
		});

		// ── Comprar Loja ───────────────────────────────────────────────────────
		initSwiperLazy(".shop-buy-slider", {
			slidesPerView: 3,
			spaceBetween: 32,
			navigation: {
				nextEl: ".shop-buy-slider .swiper-buttons .swiper-button-next",
				prevEl: ".shop-buy-slider .swiper-buttons .swiper-button-prev",
			},
			pagination: { el: ".shop-buy-slider .swiper-pagination", clickable: true },
			breakpoints: {
				0:   { slidesPerView: 1 },
				768: { navigation: false, allowTouchMove: false, pagination: false },
			},
		});

		// ── Pix / Crédito ──────────────────────────────────────────────────────
		initSwiperLazy(".credit-pix-slider", {
			slidesPerView: 4,
			spaceBetween: 24,
			freeMode: true,
			pagination: { el: ".credit-pix-slider .swiper-pagination", clickable: true },
			breakpoints: {
				0:   { slidesPerView: "auto", spaceBetween: 24 },
				768: { pagination: false, allowTouchMove: false },
			},
		});

		// ── CDB DM: Vantagens ──────────────────────────────────────────────────
		initSwiperLazy(".cdb-advantages-slider", {
			slidesPerView: "auto",
			spaceBetween: 16,
			navigation: {
				nextEl: ".cdb-advantages .swiper-buttons .swiper-button-next",
				prevEl: ".cdb-advantages .swiper-buttons .swiper-button-prev",
			},
			pagination: { el: ".cdb-advantages-slider .swiper-pagination", clickable: true },
			breakpoints: {
				992: { slidesPerView: 4, spaceBetween: 24, allowTouchMove: false },
			},
		});

		// ── CDB DM: Opções ─────────────────────────────────────────────────────
		initSwiperLazy(".cdb-options-slider", {
			slidesPerView: "auto",
			spaceBetween: 16,
			navigation: {
				nextEl: ".cdb-options .swiper-buttons .swiper-button-next",
				prevEl: ".cdb-options .swiper-buttons .swiper-button-prev",
			},
			pagination: { el: ".cdb-options-slider .swiper-pagination", clickable: true },
			breakpoints: {
				992: { slidesPerView: 3, spaceBetween: 24 },
			},
		});

		// ── Limite ─────────────────────────────────────────────────────────────
		initSwiperLazy(".limit-slider", {
			slidesPerView: 5,
			spaceBetween: 60,
			navigation: {
				nextEl: ".limit-slider .swiper-buttons .swiper-button-next",
				prevEl: ".limit-slider .swiper-buttons .swiper-button-prev",
			},
			pagination: { el: ".limit-slider .swiper-pagination", clickable: true },
			breakpoints: {
				0:   { slidesPerView: 1 },
				768: { navigation: false, allowTouchMove: false, pagination: false },
			},
		});

		// ── Categorias de Bônus ───────────────────────────────────────────────
		initSwiperLazy(".bonus-categories-slider", {
			slidesPerView: 4,
			spaceBetween: 24,
			grid: { rows: 4, fill: 'row' },
			navigation: {
				nextEl: ".bonus-categories-slider .swiper-buttons .swiper-button-next",
				prevEl: ".bonus-categories-slider .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0:   { slidesPerView: 'auto', spaceBetween: 24, grid: { rows: 2, fill: 'row' } },
				768: { navigation: false, allowTouchMove: false },
			},
		});

		// ── Soluções de Segurança ──────────────────────────────────────────────
		initSwiperLazy(".safety-solutions-slider", {
			slidesPerView: 3,
			spaceBetween: 24,
			grid: { rows: 3, fill: 'row' },
			navigation: {
				nextEl: ".safety-solutions-slider .swiper-buttons .swiper-button-next",
				prevEl: ".safety-solutions-slider .swiper-buttons .swiper-button-prev",
			},
			breakpoints: {
				0:   { slidesPerView: 1, spaceBetween: 24, grid: { rows: 2, fill: 'row' } },
				768: { navigation: false, allowTouchMove: false },
			},
		});

		// ── Chances de Empréstimo ──────────────────────────────────────────────
		initSwiperLazy(".loan-chances-slider", {
			slidesPerView: 'auto',
			spaceBetween: 16,
			freeMode: true,
			pagination: { el: ".loan-chances-slider .swiper-pagination", clickable: true },
		});

		// ── Ganhadores ────────────────────────────────────────────────────────
		initSwiperLazy(".winners-slider", {
			slidesPerView: 1,
			spaceBetween: 5,
			navigation: {
				nextEl: ".winners-slider .swiper-buttons .swiper-button-next",
				prevEl: ".winners-slider .swiper-buttons .swiper-button-prev",
			},
		});

		// ── Posts relacionados ────────────────────────────────────────────────
		initSwiperLazy(".related-posts-slider", {
			slidesPerView: 4,
			spaceBetween: 24,
			pagination: { el: ".related-posts-slider .swiper-pagination", clickable: true },
			breakpoints: {
				0:   { slidesPerView: 'auto', spaceBetween: 20, freeMode: true },
				768: { allowTouchMove: false, pagination: false },
			},
		});

		// ── BLOG NOVIDADES (slider com controle do slide "ver mais") ──────────
		initSwiperLazy(".blog-news-slider", {
			slidesPerView: 2,
			spaceBetween: 20,
			slidesPerGroup: 1,
			loop: true,
			autoplay: { delay: 4000, disableOnInteraction: false },
			pagination: { el: '.blog-news-slider .swiper-pagination', clickable: true },
			breakpoints: {
				0:   { slidesPerView: "auto", slidesPerGroup: 1, spaceBetween: 16, freeMode: true, loop: false, autoplay: false },
				768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
			},
			on: {
				paginationUpdate: function () {
					const isMobile = window.innerWidth <= 768;
					const bullets  = this.pagination.bullets;
					const slides   = this.slides;

					bullets.forEach(b => b.style.display = '');

					if (!isMobile) return;

					const last = slides[slides.length - 1];
					if (last?.classList.contains('slide-ver-mais') && bullets[bullets.length - 1]) {
						bullets[bullets.length - 1].style.display = 'none';
					}
				},
			},

		}, function (blognewsSlider) {

			let slideHTML = null;

			function captureSlide() {
				const slide = document.querySelector('.blog-news-slider .slide-ver-mais');
				if (!slide) return;

				slideHTML = slide.outerHTML;

				if (window.innerWidth > 768) {
					slide.remove();
					blognewsSlider.update();
					blognewsSlider.pagination.render();
					blognewsSlider.pagination.update();
				}
			}

			function handleSlide() {
				const isMobile    = window.innerWidth <= 768;
				const slidesArray = [...blognewsSlider.slides];
				const exists      = slidesArray.some(s => s.classList.contains('slide-ver-mais'));

				if (isMobile && !exists && slideHTML) {
					blognewsSlider.appendSlide(slideHTML);
					blognewsSlider.update();
					blognewsSlider.pagination.render();
					blognewsSlider.pagination.update();
				}

				if (!isMobile && exists) {
					const idx = slidesArray.findIndex(s => s.classList.contains('slide-ver-mais'));
					if (idx !== -1) {
						blognewsSlider.removeSlide(idx);
						blognewsSlider.update();
						blognewsSlider.pagination.render();
						blognewsSlider.pagination.update();
					}
				}
			}

			captureSlide();
			handleSlide();

			let resizeTimeout;
			window.addEventListener('resize', () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(handleSlide, 300);
			});
		});

		// ── VÍDEOS BLOG ───────────────────────────────────────────────────────
		initSwiperLazy(".blog-videos-slider", {
			slidesPerView: 'auto',
			spaceBetween: 40,
			preventClicks: false,
			preventClicksPropagation: false,
			pagination: { el: ".blog-videos-slider .swiper-pagination", clickable: true },
			breakpoints: {
				0:   { slidesPerView: 'auto', spaceBetween: 20, freeMode: true },
				768: { allowTouchMove: false, pagination: false },
			},
			on: {
				init: function () { _removeLastBullet(this); },
				slideChange: function () { _removeLastBullet(this); },
			},
		});

		function _removeLastBullet(swiper) {
			const total = swiper.slides.length;
			swiper.pagination.bullets.forEach((b, i) => {
				b.style.display = i === total - 1 ? 'none' : '';
			});
		}
	}

	// ─── INIT ─────────────────────────────────────────────────────────────────
	$(document).ready(function () {
		sliders();
	});

})(jQuery);
